import * as React from 'react';

import './LeftSideMenu.less';

interface Props {
  bottomPanel?: any;
  topPanel?: any;
  className?: string;
}

const LeftSideMenu: React.FunctionComponent<Props> = ({
  children,
  bottomPanel = null,
  topPanel = null,
  className,
}) => (
  <div className={`left-side-menu ${className ? className : ''}`}>
    <div className="left-side-menu__navigation">
      {topPanel && <div className="left-side-menu__panel">{topPanel}</div>}
      <div>{children}</div>
    </div>
    {bottomPanel}
  </div>
);

export default LeftSideMenu;



// WEBPACK FOOTER //
// ./src/components/LeftSideMenu/LeftSideMenu.tsx